import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_western-rail-hub/artifacts/9lbwvitg_AGWR_20260514_060630_0000.png" 
              alt="AG&W Logo" 
              className="footer-logo-image"
            />
            <p className="footer-tagline">RELAX. EXPLORE. LIVE.</p>
            <p className="footer-description">
              Delivering efficient transportation solutions in freight and passenger rail services since December 2025.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/team">Team</Link></li>
              <li><Link to="/projects">Routes & Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={18} />
                <span>info@agwesternrail.com</span>
              </li>
              <li>
                <Phone size={18} />
                <span>(866) 324-9378</span>
              </li>
              <li>
                <MapPin size={18} />
                <span>Richmond, Virginia</span>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Follow Us</h4>
            <div className="footer-social">
              <a href="#" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="#" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="#" aria-label="Facebook">
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} AG&WESTERN Rail Inc. All rights reserved. Founded December 23, 2025.</p>
            <a 
              href="/portal/login" 
              className="employee-portal-link"
            >
              Employee Portal
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;